import { Box, Grid, Typography } from "@material-ui/core";
import ReportForm from "./reportForm";

export default function ReportEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
        Report &gt; Edit Report
        </Typography>
      </Box>
      <Grid container xs={6}>
        <ReportForm
          description="Edit Report"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
